import ArticleInfo from './ArticleInfo';

export { ArticleInfo };
